<template>
  <svg
    class="iconFont"
    aria-hidden="true"
    style="outline-style: none"
    xmlns="http://www.w3.org/2000/svg"
    @click="handleClick"
  >
    <use
      v-bind:xlink:href="iconName"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    />
  </svg>
</template>

<script>
export default {
  name: "SvgIcon",
  props: {
    iconClass: {
      type: String,
      required: true,
    },
  },
  computed: {
    // 引入的图标名称
    iconName() {
      return `#icon-${this.iconClass}`;
    },
  },
  methods: {
    handleClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style lang="scss" scoped>
.iconFont {
  width: 16px;
  height: 16px;
}
</style>
